import {SPACE} from '@lookiero/aurora';

export const SECTION_SPACE = {default: SPACE.SPACE_6, L: SPACE.SPACE_8};
